import { render, staticRenderFns } from "./PrivateMessage.vue?vue&type=template&id=5c5ba01a&"
import script from "./PrivateMessage.vue?vue&type=script&lang=js&"
export * from "./PrivateMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports